export const HAPPY_AUTOMATA_ACTOR = "did:plc:ta7md6dgr25hz4kztzx2v54o";
